import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Card } from './ui/card';
import { X } from 'lucide-react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  // Cookie policy version - increment when cookie policy changes
  const COOKIE_POLICY_VERSION = '1.0';

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    const consentVersion = localStorage.getItem('cookieConsentVersion');
    
    // Show if no consent exists or if consent version is outdated
    if (!consent || consentVersion !== COOKIE_POLICY_VERSION) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentVersion', COOKIE_POLICY_VERSION);
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    localStorage.setItem('cookieConsentVersion', COOKIE_POLICY_VERSION);
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-md">
      <Card className="bg-background/95 backdrop-blur-sm border-border shadow-lg">
        <div className="p-4">
          <div className="flex justify-between items-start mb-3">
            <h3 className="font-semibold text-foreground">Cookie-Einstellungen</h3>
            <Button
              variant="ghost"
              size="sm"
              onClick={handleDecline}
              className="h-6 w-6 p-0"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
          <p className="text-sm text-muted-foreground mb-4">
            Wir verwenden Cookies, um Ihre Erfahrung zu verbessern und den Website-Traffic zu analysieren. 
            Durch die Nutzung unserer Website stimmen Sie der Verwendung von Cookies zu.
          </p>
          <div className="flex gap-2">
            <Button
              onClick={handleAccept}
              size="sm"
              className="flex-1"
            >
              Akzeptieren
            </Button>
            <Button
              onClick={handleDecline}
              variant="outline"
              size="sm"
              className="flex-1"
            >
              Ablehnen
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default CookieConsent;